<template>
  <div id="session" @error="errorHandler">
    <publisher
      :session="session"
      :end-point="endPoint"
      :token="token"
      :session-id="sessionId"
      @error="errorHandler"
      v-if="isPublisherVisible"
    ></publisher>
    <!-- <div id="subscribers" v-for="stream in streams" :key="stream.streamId">
      <subscriber @error="errorHandler" :stream="stream" :session="session"></subscriber>
    </div> -->
  </div>
</template>

<script>
import OT from "@opentok/client";
import Publisher from "./Publisher";
// import Subscriber from './Subscriber.vue';
const errorHandler = err => {
  console.log(err.message);
};
export default {
  name: "Session",
  components: { Publisher },
  props: {
    endPoint: { type: String, required: true },
    token: { type: String, required: true },
    operationUuid: { type: String, required: true }
  },
  data: () => ({
    streams: [],
    session: null,
    sessionId: String,
    isPublisherVisible: false
  }),
  created() {
    this.$http.defaults.headers.common.Authorization = this.token;
    this.$http.get(`${this.endPoint}${"session/"}${this.operationUuid}`).then(
      response => {
        this.EventBus.$emit("videoUuid", response.data.videoUuid);
        this.sessionId = response.data.sessionId;
        this.session = OT.initSession(
          response.data.apiKey,
          response.data.sessionId
        );
        this.session.connect(response.data.token, err => {
          if (err) {
            errorHandler(err);
            this.EventBus.$emit("cannotInitIdentification");
          }
        });
        this.session.on("streamCreated", event => {
          this.streams.push(event.stream);
        });
        this.session.on("streamDestroyed", event => {
          const idx = this.streams.indexOf(event.stream);
          if (idx > -1) {
            this.streams.splice(idx, 1);
          }
        });
        this.session.on("sessionConnected", event => {
          this.isPublisherVisible = true;
          this.$emit("initRecorder", event);
        });
      },
      error => {
        console.log("Cannot create session");
      }
    );
  },
  methods: {
    errorHandler
  }
};
</script>

<style>
.OT_subscriber {
  float: left;
}
.OT_publisher {
  float: left;
}
</style>
